import React from 'react';
import { motion } from 'framer-motion';
import { 
  TrendingUp, Building2, Microscope, Lightbulb, 
  Target, Rocket
} from 'lucide-react';

const ImpactScorecard = ({ impact }) => {
  if (!impact) {
    return (
      <div className="text-center py-12 text-slate-400">
        <TrendingUp className="w-12 h-12 mx-auto mb-3 opacity-50" />
        <p>Impact analysis not available</p>
      </div>
    );
  }

  const appIcons = [Microscope, Building2, Lightbulb, Rocket, Target];

  return (
    <div className="space-y-8" data-testid="impact-scorecard">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-xl bg-slate-800">
          <TrendingUp className="w-5 h-5 text-teal-400" />
        </div>
        <h2 className="text-xl font-heading font-bold text-white">Impact Scorecard</h2>
      </div>

      {/* Industry Relevance */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="p-6 rounded-2xl bg-slate-800/50 border border-slate-700/50"
      >
        <div className="flex items-center gap-2 mb-4">
          <Building2 className="w-5 h-5 text-teal-400" />
          <h3 className="font-heading font-semibold text-white">Industry Relevance</h3>
        </div>
        <p className="text-slate-300 leading-relaxed">
          {impact.industry_relevance || 'Not clearly stated'}
        </p>
      </motion.div>

      {/* Real-World Applications */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <div className="flex items-center gap-2 mb-4">
          <Rocket className="w-5 h-5 text-emerald-400" />
          <h3 className="font-heading font-semibold text-white">Real-World Applications</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {(impact.real_world_applications || []).map((app, index) => {
            const Icon = appIcons[index % appIcons.length];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 + index * 0.1 }}
                className="p-4 rounded-xl bg-slate-800/30 border border-slate-700/30 hover:border-teal-400/30 transition-colors"
              >
                <div className="flex items-start gap-3">
                  <div className="p-2 rounded-lg bg-slate-700/50">
                    <Icon className="w-4 h-4 text-teal-400" />
                  </div>
                  <p className="text-sm text-slate-300 leading-relaxed">{app}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </motion.div>
    </div>
  );
};

export default ImpactScorecard;
